import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

interface ArticleItem {
  slug: string;
  title: string;
  desc: string;
  tags: string[];
  imgUrl: string;
  category: string;
}

const articles: ArticleItem[] = [
  {
    slug: '/oopbuy-spreadsheet-guide',
    title: 'OOPBuy Spreadsheet 2026: Die komplette Anleitung für Deutschland',
    desc: 'Von der ersten Suche bis zur sicheren Bestellung – unser ausführlicher Guide erklärt Produktlisten, QC-Bilder und Versandoptionen.',
    tags: ['OOPBuy Guide', 'Deutschland', 'Anfänger'],
    imgUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20desk%20with%20an%20open%20laptop%20showing%20colorful%20spreadsheet%2C%20surrounded%20by%20neatly%20arranged%20fashion%20sneakers%20and%20accessories%2C%20warm%20natural%20light%20from%20side%20window%2C%20cream%20and%20beige%20tones%2C%20editorial%20workspace%20photography%2C%20sophisticated%20organized%20composition&width=600&height=420&seq=article-tease-01-v2&orientation=landscape',
    category: 'SEO Guide',
  },
  {
    slug: '/versand-guide',
    title: 'OOPBuy Versand nach Deutschland: Alle Optionen im Vergleich',
    desc: 'Versandkosten, Lieferzeiten und Zoll – erfahre, welche Versandlinie für dein Paket die beste und günstigste ist.',
    tags: ['Versand', 'DHL', 'Zoll'],
    imgUrl: 'https://readdy.ai/api/search-image?query=Elegant%20packaged%20box%20wrapped%20in%20kraft%20paper%20with%20twine%20on%20a%20warm%20cream%20desk%2C%20surrounded%20by%20small%20fashion%20accessories%2C%20natural%20daylight%2C%20shipping%20and%20logistics%20concept%2C%20minimalist%20editorial%20product%20photography%2C%20soft%20taupe%20tones&width=600&height=420&seq=article-tease-02-v2&orientation=landscape',
    category: 'Versand',
  },
  {
    slug: '/qc-guide',
    title: 'OOPBuy QC Guide: Qualitätskontrolle vor dem Versand meistern',
    desc: 'Lerne QC-Bilder richtig zu interpretieren, erkenne Mängel sofort und stelle sicher, dass du nur Top-Qualität erhältst.',
    tags: ['QC Bilder', 'Qualität', 'Sicherheit'],
    imgUrl: 'https://readdy.ai/api/search-image?query=Close%20up%20detail%20shot%20of%20hands%20holding%20a%20magnifying%20glass%20over%20a%20premium%20sneaker%20examining%20stitching%20quality%2C%20warm%20cream%20background%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20inspection%20photography%2C%20sophisticated%20quality%20control%20concept&width=600&height=420&seq=article-tease-03-v2&orientation=landscape',
    category: 'QC Guide',
  },
  {
    slug: '/oopbuy-vs-pandabuy',
    title: 'OOPBuy vs Pandabuy 2026: Der ehrliche Vergleich',
    desc: 'Preise, Versand, QC-Qualität und Support im direkten Vergleich – welcher Agent ist besser für deutsche Käufer?',
    tags: ['Vergleich', 'Pandabuy', 'Kosten'],
    imgUrl: 'https://readdy.ai/api/search-image?query=Split%20composition%20showing%20two%20groups%20of%20fashion%20items%20facing%20each%20other%20on%20a%20warm%20cream%20surface%2C%20soft%20balanced%20lighting%2C%20editorial%20comparison%20concept%2C%20minimalist%20product%20arrangement%2C%20beige%20and%20taupe%20color%20palette%2C%20sophisticated%20visual%20balance&width=600&height=420&seq=article-tease-04-v2&orientation=landscape',
    category: 'Vergleich',
  },
  {
    slug: '/oopbuy-spreadsheet-guide',
    title: 'Die besten OOPBuy Sneaker 2026: Unsere Top 50 Auswahl',
    desc: 'Nike, Jordan, Yeezy und mehr – wir haben die beliebtesten Sneaker aus dem OOPBuy Spreadsheet zusammengestellt.',
    tags: ['Sneaker', 'Nike', 'Trend'],
    imgUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimal%20arrangement%20of%20three%20pairs%20of%20stylish%20sneakers%20in%20different%20neutral%20colors%20on%20a%20warm%20cream%20surface%2C%20natural%20soft%20side%20lighting%2C%20editorial%20product%20photography%2C%20sophisticated%20footwear%20display%2C%20taupe%20and%20beige%20background%2C%20clean%20composition&width=600&height=420&seq=article-tease-05-v2&orientation=landscape',
    category: 'Produkte',
  },
  {
    slug: '/versand-guide',
    title: 'OOPBuy Zoll Deutschland: So vermeidest du hohe Gebühren',
    desc: 'Verstehe die deutschen Zollregeln, deklariere richtig und spare bares Geld bei deinen Bestellungen aus China.',
    tags: ['Zoll', 'Gebühren', 'Sparen'],
    imgUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimal%20desk%20scene%20with%20official%20looking%20documents%20and%20a%20calculator%20next%20to%20a%20small%20package%2C%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20customs%20and%20finance%20concept%2C%20sophisticated%20editorial%20photography%2C%20organized%20clean%20aesthetic&width=600&height=420&seq=article-tease-06-v2&orientation=landscape',
    category: 'Zoll',
  },
  {
    slug: '/qc-guide',
    title: 'QC Bilder bei OOPBuy: Die häufigsten Mängel erkennen',
    desc: 'Falsche Größen, Farbabweichungen, Logo-Fehler – erfahre, worauf du bei QC-Bildern besonders achten musst.',
    tags: ['QC', 'Mängel', 'Prüfung'],
    imgUrl: 'https://readdy.ai/api/search-image?query=Detailed%20macro%20photography%20of%20clothing%20label%20and%20size%20tag%20being%20inspected%20closely%2C%20warm%20cream%20background%2C%20soft%20diffused%20studio%20light%2C%20editorial%20quality%20control%20detail%20photography%2C%20sophisticated%20textile%20inspection%20aesthetic&width=600&height=420&seq=article-tease-07-v2&orientation=landscape',
    category: 'QC Tipps',
  },
  {
    slug: '/versand-guide',
    title: 'OOPBuy Versandkosten sparen: 10 Experten-Tipps 2026',
    desc: 'Bündeln, Verpackung optimieren und die richtige Versandlinie wählen – so reduzierst du deine Versandkosten um bis zu 50%.',
    tags: ['Sparen', 'Tipps', 'Experte'],
    imgUrl: 'https://readdy.ai/api/search-image?query=Elegant%20composition%20of%20stacked%20neatly%20wrapped%20kraft%20paper%20packages%20tied%20with%20natural%20twine%20on%20a%20warm%20cream%20desk%2C%20soft%20natural%20window%20light%2C%20minimalist%20shipping%20concept%2C%20sophisticated%20editorial%20product%20photography%2C%20taupe%20and%20beige%20tones&width=600&height=420&seq=article-tease-08-v2&orientation=landscape',
    category: 'Tipps',
  },
  {
    slug: '/oopbuy-spreadsheet-guide',
    title: 'OOPBuy für Anfänger: Erste Bestellung Schritt für Schritt',
    desc: 'Noch nie aus China bestellt? Mit dieser Schritt-für-Schritt-Anleitung gelingt deine erste OOPBuy-Bestellung garantiert.',
    tags: ['Anfänger', 'Tutorial', 'Erste Schritte'],
    imgUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20beginner%20workspace%20with%20an%20open%20notebook%20showing%20numbered%20steps%2C%20a%20smartphone%20displaying%20a%20shopping%20app%2C%20and%20a%20warm%20coffee%20cup%2C%20natural%20morning%20light%2C%20cream%20background%2C%20educational%20editorial%20photography%2C%20soft%20inviting%20tones&width=600&height=420&seq=article-tease-09-v2&orientation=landscape',
    category: 'Anfänger',
  },
  {
    slug: '/oopbuy-vs-pandabuy',
    title: 'China Shopping Agent Vergleich: Wer bietet das beste Gesamtpaket?',
    desc: 'OOPBuy, Pandabuy, Sugargoo und CSSBuy im großen Vergleich – finde den perfekten Agenten für deine Bedürfnisse.',
    tags: ['Agenten', 'Vergleich', 'Shopping'],
    imgUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimal%20desk%20with%20four%20neatly%20arranged%20groups%20of%20small%20fashion%20items%20representing%20different%20brands%2C%20warm%20cream%20surface%2C%20balanced%20natural%20lighting%2C%20editorial%20comparison%20concept%2C%20sophisticated%20beige%20and%20taupe%20color%20palette%2C%20clean%20organized%20composition&width=600&height=420&seq=article-tease-10-v2&orientation=landscape',
    category: 'Vergleich',
  },
];

export default function ArticleTeaser() {
  const { t } = useTranslation();

  const handleArticleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
            {t('article.more_articles')}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Entdecke unsere ausführlichen Guides rund um OOPBuy Spreadsheet, Versand, Qualitätskontrolle und Produktvergleiche.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article, idx) => (
            <Link
              key={`${article.slug}-${idx}`}
              to={article.slug}
              onClick={handleArticleClick}
              className="group bg-background-100 rounded-xl border border-background-200/70 hover:border-accent-300 overflow-hidden transition-all cursor-pointer flex flex-col"
            >
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={article.imgUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <span className="text-xs font-bold text-accent-600 bg-accent-100 px-2.5 py-1 rounded-full inline-block w-fit mb-3">
                  {article.category}
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-accent-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed mb-4 line-clamp-3 flex-1">
                  {article.desc}
                </p>
                <div className="flex flex-wrap gap-1.5 mb-3">
                  {article.tags.map((tag) => (
                    <span key={tag} className="text-xs text-foreground-500 bg-background-200/70 px-2 py-0.5 rounded-full">
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="flex items-center gap-1 text-xs font-medium text-accent-600 mt-auto">
                  <span>{t('article.read_guide')}</span>
                  <i className="ri-arrow-right-line text-xs group-hover:translate-x-0.5 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-rocket-line"></i>
            Alle Produkte im Spreadsheet entdecken
          </a>
        </div>
      </div>
    </section>
  );
}